import { render, staticRenderFns } from "./wtToggle.component.vue?vue&type=template&id=1710b12b&"
import script from "./wtToggle.component.vue?vue&type=script&lang=js&"
export * from "./wtToggle.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports